import { render, staticRenderFns } from "./toHome.vue?vue&type=template&id=640fa396&"
import script from "./toHome.vue?vue&type=script&lang=js&"
export * from "./toHome.vue?vue&type=script&lang=js&"
import style0 from "./toHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports